import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SectionSection from "../../../shared/Section";
import Iframe from "../../../shared/utilities/IFrame";

function ArcGISExperienceEmbedTest(props) {
  const [reportName, setReportName] = useState(
    "HWTS Facilities (ESRI Experience Builder Test)"
  );
  document.title = reportName;

  return (
    <div>
      <SectionSection
        title={
          <Link to="/reports" style={{ color: "white" }}>
            {reportName}
          </Link>
        }
        type={"standout"}
      />
      <div className="" style={{ position: "relative", width: "100%" }}>
        <Iframe source="https://experience.arcgis.com/experience/8d54987df3c24ba5b4ff88e5b987a8cb" />
      </div>
    </div>
  );
}

export default ArcGISExperienceEmbedTest;
